// This fuction using exsiting JWT and append to
//certain routes to fetch or making update without haveing user logged-in
export const getJWT = () => {
  const jwtElement: HTMLMetaElement | null = document.querySelector('[name=react-app-jwt]');
  let jwtParams = {};
  if (jwtElement?.content) {
    jwtParams = {
      jwt: jwtElement.content,
    };
  }
  return jwtParams;
};
